import React from 'react';
export const CFIconPaperPlane = {
    alias: 'paper-plane',
    defaultTitle: 'PaperPlane',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'm15 17.838-1.855-5.567 5.567-5.569-3.711 11.136Zm2.296-12.55-5.568 5.568L6.16 9l11.136-3.712Zm4.694-2.34a.951.951 0 0 0-.088-.361.967.967 0 0 0-.195-.294.96.96 0 0 0-.384-.23.987.987 0 0 0-.275-.054c-.022-.001-.042-.006-.065-.006-.1.002-.201.016-.299.048l-18 6a1 1 0 0 0 0 1.898l8.525 2.842 2.843 8.526a.998.998 0 0 0 1.896 0l6-18a1 1 0 0 0 .048-.3c.001-.023-.005-.045-.006-.07Z' }))),
};
